<template>
  <b-card
    tag="b-link"
    :to="item.targetUrl"
    :img-src="fileUrl(this.getImage(item.imageUrl))"
    :img-alt="item.title"
    img-top
    :class="{ 'card-style' : skin === 'cloob' ||  skin === 'put' ||  skin === 'jabe'}"
    class="component-product-card d-flex flex-column align-items-stretch game text-dark border-0"
    no-body
  >
    <div class="text-align-start d-flex flex-column justify-content-between p-md-2 p-xxs-1 flex-grow-1">
      <strong v-text="item.title" />
      <small class="d-flex flex-row-reverse text-muted" v-text="item.genre" />
    </div>
    <StarRating 
      v-if="skin === 'cloob' || skin === 'put' || skin === 'jabe'"
      :max-rating="5" 
      :star-size="20" 
      :read-only="true" 
      :border-width="0"
      border-color="rgba(0, 0, 0, 0)"
      :show-rating="false" 
      inactive-color="#fff"
      active-color="#999"
      v-model="rate" />
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'
import windowSize from '@/mixins/window-size'
import StarRating from 'vue-star-rating'

export default {
  name: 'GameCard',
  mixins: [windowSize],
  components: { StarRating },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      rate: Math.floor(Math.random() * 5) + 1  ,
      isImageLoaded: false,
      skin: null
    }
  },
  created(){
    this.skin = this.portalConfigurations.general.Skin
  },
  computed: {
    ...mapGetters({
      fileUrl: 'cdn/fileUrl',
      portalConfigurations: 'tenantDesign/config'
    })
  },
  methods: {
    getImage (src) {
      if (this.skin === 'cloob' || this.skin === 'put' || this.skin === 'jabe') {
        var size = this.isMaxWidth768() ? '?w=170' : '?w=280'
      } else {
        var size = this.isMaxWidth480() ? '?w=80' : '?w=150'
      }
      var result = src + size
      return result
    },
    loaded () {
      this.isImageLoaded = true
    },
  }
}
</script>
